module.exports = __webpack_public_path__ + "img/doli.f9dc0076.png";